export default {
  items: [],
  isModalOpen: false,
  specialistToUpdate: {
    id: null,
    name: '',
    phone: '',
    imageLink: '',
    active: true,
  },
  specialistsToUpdateOrder: [],
};
